import { LoadingButton } from "@mui/lab";
import {
  Dialog,
  DialogTitle,
  Button,
  DialogActions,
  FormControlLabel,
  Radio,
  RadioGroup,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import axios from "axios";
import { t } from "i18next";
import { useContext, useState } from "react";
import { config } from "../../../config/config";
import {
  ProjectDetailContext,
  UseSnackbarContext,
} from "../../../pages/ProjectDetail";
import { ProjectDetailUtil } from "../../Utility/ProjectDetailUtil";
import { makeStyles } from "@material-ui/core";
import { Common } from "../../../../common/src";

type RegPointworksProps = {
  open: boolean;
  close?: () => void;
  onClose?: () => void;
  onCancel?: () => void;
};

const RegisterWithPointworks = (regPointworksProps: RegPointworksProps) => {
  const { projectDetail, isJapanese } = useContext(ProjectDetailContext);
  const { openSuccess, openError } = useContext(UseSnackbarContext);

  /*****************************************
		state
	******************************************/
  const [whileUpload, setWhilUpload] = useState<boolean>(false);
  const [radioCoordinates, setRadioCoordinates] =
    useState<Common.POINT_CLOUD_TYPE>(Common.POINT_CLOUD_TYPE.SFM); //「点群を選択」

  /*****************************************
		function
	******************************************/
  const handleRegPointworksCancel = () => {
    regPointworksProps.close();
  };

  const handleRegPointworksOK = async () => {
    setWhilUpload(true);
    await regPointworks()
      .then(() => {
        openSuccess(t("OK"));
        regPointworksProps.close();
      })
      .catch((errMsg) => {
        if (errMsg === "CON_ERR") openError(t("MSG00132"));
        else openError(t("ERROR"));
      })
      .finally(() => {
        setWhilUpload(false);
      });
  };

  // Pointworks連携API
  const regPointworks = () => {
    return new Promise<void>(async (resolve, reject) => {
      await axios
        .post(
          `${config.serverHost}/api/v1/scpointwork/${projectDetail?.id}/upload`,
          { pointType: radioCoordinates },
          {
            withCredentials: true,
            onUploadProgress: (progressEvent) => {
              Math.round((progressEvent.loaded * 100) / progressEvent.total);
            },
          }
        )
        .then(() => {
          return resolve();
        })
        .catch((err) => {
          // SC-Pointworksの連携失敗の場合
          if (err?.response?.data === "CON_ERR") return reject("CON_ERR");
          // 上記以外
          else return reject();
        });
    });
  };

  /*****************************************
		style
	******************************************/
  const cssStyles = makeStyles({
    radioStyleComm: {
      color: "#FFFFFF",
      display: "flex",
      justifyContent: "flex-start",
    },
    radioStyle1: { left: "20px" },
    radioStyle2: { left: "200px" },
    isLanguageRadioStyle2: { left: "20px", width: "450px", top: "110px" },
  });
  const userStyle = cssStyles();

  return (
    <>
      <Dialog
        open={regPointworksProps.open}
        onClose={regPointworksProps.onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        color="white"
        PaperProps={{ className: "pointworks01" }}
      >
        <DialogTitle className="title-name">
          {t("UPLOAD_SMART_POINTWORKS")}
          <Button className="btn-x" onClick={regPointworksProps.close}>
            ×
          </Button>
          <div id="border-comm" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            className="pointworks02"
            sx={{ marginBottom: "12px" }}
          >
            「{projectDetail?.name}」{t("UPLOAD_MANY_SMART_POINTWORKS")}
          </DialogContentText>
          <DialogContentText
            className="pointworks02"
            sx={{ textAlign: "center" }}
          >
            {t("SELECT_POINT_CLOUD")}
          </DialogContentText>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <RadioGroup sx={{ flexDirection: "inherit" }}>
              <FormControlLabel
                label={t("ORIGINAL_SFM_POINT")}
                disabled={
                  !projectDetail.useViDoc ||
                  !ProjectDetailUtil.isSfMComplete(projectDetail.status)
                }
                className={`${userStyle.radioStyleComm} ${userStyle.radioStyle1}`}
                control={
                  <Radio
                    checked={radioCoordinates === Common.POINT_CLOUD_TYPE.SFM}
                    onChange={() =>
                      setRadioCoordinates(Common.POINT_CLOUD_TYPE.SFM)
                    }
                  />
                }
              />
              <FormControlLabel
                label={t("TRANSFOR_SFM_POINT")}
                disabled={
                  !ProjectDetailUtil.isHelmartComplete(projectDetail.status)
                }
                className={
                  isJapanese
                    ? `${userStyle.radioStyleComm} ${userStyle.radioStyle2}`
                    : `${userStyle.radioStyleComm} ${userStyle.isLanguageRadioStyle2}`
                }
                control={
                  <Radio
                    checked={
                      radioCoordinates === Common.POINT_CLOUD_TYPE.HELMERT
                    }
                    onChange={() =>
                      setRadioCoordinates(Common.POINT_CLOUD_TYPE.HELMERT)
                    }
                  />
                }
              />
            </RadioGroup>
          </DialogActions>
          <DialogActions sx={{ display: "flex", justifyContent: "flex-start" }}>
            <Button
              onClick={handleRegPointworksCancel}
              className="pointworks04"
              variant="contained"
              size="small"
              sx={{ borderRadius: "0px" }}
            >
              {t("CANCEL")}
            </Button>
            <LoadingButton
              className="loading-white pointworks05"
              loading={whileUpload}
              color="primary"
              variant="contained"
              size="small"
              onClick={handleRegPointworksOK}
              sx={{ borderRadius: "0px" }}
            >
              {t("MSG00131")}
            </LoadingButton>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default RegisterWithPointworks;
